export const uniqueKeys = (values: readonly string[]): string[] => {
  const seen = new Map<string, number>();

  return values.map((value) => {
    const occurrence = seen.get(value) ?? 0;
    seen.set(value, occurrence + 1);
    return occurrence === 0 ? value : `${value}-${occurrence}`;
  });
};
